import api from '@/libs/axios'


export default {
  async create(payload) {
    const response = await api.post('/admin/native-talks', payload)
    return response.data.data.new_document || null
  },
  async update(payload) {
    let response = await api.put('/admin/native-talks', { data: JSON.stringify(payload) })
    return response
  },
  async delete(payload) {
    const response = await api.post('/admin/native-talks/deactive', payload)
    return response
  },
  async getList(params) {
    let response = await api.get('/admin/native-talks', {
      params,
    })
    return response.data.data
  },
  async get(params) {
    let response = await api.get('/admin/native-talks/detail', {
      params,
    })
    return response.data.data.document || null
  },
}
